<template>
  <div class="content">
    <div class="container-fluid">
        <div class="row">
          <div style="width:100%">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>PPOE</th>
                      <th>Paket</th>
                      <th>Area</th>
                      <th>Biaya</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody v-show="loading">
                      <tr>
                        <td colspan="7"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="7"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="7"><Loading></Loading></td>
                      </tr>
                    </tbody>
                    <tbody v-show="!loading">
                      <tr v-if="pelanggan == null"><td></td><td>Tidak ada Data</td></tr>
                      <tr v-for="(u, index) in pelanggan">
                        <td>{{ index+1 }}</td>
                        <td><strong>{{ u.user.unama }}</strong></br>{{ u.user.wa }}</td>
                        <td><span class="text-info">{{ u.user.ppoe }}</span></td>
                        <td>{{ u.user.pnama }}</br>Tagihan Tgl {{ u.user.tanggal_tagihan }}</td>
                        <td>{{ u.area }}</td>
                        <td>
                          {{ ribu( 
                            (
                               ( parseInt(u.user.ptarif) + parseInt(isNull(u.user.biaya_tambahan)) + parseInt(isNull(u.user.biaya_tambahan_2)) ) + (  ( (parseInt(u.user.ptarif) ) / 100 ) ) * parseInt(ppn)   ) - parseInt(isNull(u.user.diskon)
                              ) 
                            ) 
                            }} 
                            <i class="tombol material-icons text-info" @mouseover="infoShow = index" @mouseleave="infoShow = -1">error</i> 
                          <span class="info" v-if="infoShow == index" v-show="infoShow == index">
                            <p class="mb-0">PPN {{ppn}}% : {{ribu(parseInt(ppn) * ( parseInt(u.user.ptarif) / 100 ) )}}</p>
                            <p class="mb-0">{{u.user.biaya_rincian}} : {{ribu(u.user.biaya_tambahan) }}</p>
                            <p class="mb-0">{{u.user.biaya_rincian_2}} : {{ribu(u.user.biaya_tambahan_2) }}</p>
                            <p class="mb-0">Diskon : {{ribu(u.user.diskon) }}</p>
                          </span>
                        </td>
                        <td>
                          <router-link :to="{ name: 'pelanggan-detail', params: { id:u.user.uid, user: u.user, area: u.area  }}"  class="text-info" ><i class="material-icons">remove_red_eye</i> Detail</router-link>

                          <!-- <button v-show="isAllow()" @click="showing = index, idHapus = u.user.uid" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i> Hapus</button> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer ">
                <div class="text-center" style="width:100%">
                  <button class="btn btn-info" @click="loadMore()" v-show="pageStat != 999">Load More...</button>
                  <button class="btn btn-success" @click="loadAll(); pageStat = 999" v-show="pageStat != 999">Load All</button>
                </div>
              </div>
            </div>
          </div>
        </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import inter from '@/globalFunc/Interface' 
import myGlobal from '@/globalFunc/myGlobal' 
import Loading from '@/globalFunc/Loading' 
import { RedisSession } from '@/globalFunc/redis';

Vue.use(moment)

// EXCEL
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment,
    'Loading': Loading
  }, 
  data () {
    return {
      loading: true,
      pelanggan: [],
      
      judulDoc: '',
      nameDoc: '',
      json_fieldspelanggan: {
        "No" : 'no',
        'PPOE': 'ppoe',
        'Nama': 'nama',
        'Telepon': 'telepon',
        'Paket': 'paket',
        'Area': 'area',
        'Biaya': 'biaya',
        'Tanggal Tagihan': 'tanggal',
        'Rincian Tambahan 1': 'r1',
        'Biaya Tambahan 1': 'b1',
        'Rincian Tambahan 2': 'r2',
        'Biaya Tambahan 2': 'b2',
        'Diskon': 'diskon',
        'PPN': 'ppn',
        'Total Bayar': 'total'
      },
      json_datapelanggan: [],
      json_metapelanggan: [
          [
              {
                  'key': 'charset',
                  'value': 'utf-8'
              }
          ]
      ],

      infoShow: -1,
      totalBelum: 0,
      page: 0,
      pageStat: 0
    }
  },
  methods: {
    startDownload() {

    },
    isNull(x) {
      var a;
      if (x == null || x == "") {
        a = 0;
      } else {
        a = x
      }
      return a;
    },
    parseExcel(x,judul) {
      var data = x;
      var values = [];
      var i;
      for (i = 0; i < data.length; i++) {
        
          var telepon = data[i].user.wa;
          if (telepon.charAt(0) == "0") {
            telepon = "62"+telepon.substring(1);
          } else if (telepon.charAt(0) == "8") {
            telepon = "62"+telepon;
          }
          
          var item1 = {
              "no" : i+1,
              'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
              'telepon': telepon,
              'paket': data[i].user.pnama,
              'area': data[i].area,
              'biaya': this.ribu(data[i].user.ptarif),
              'ppoe': data[i].user.ppoe,
              'tanggal': data[i].user.tanggal_tagihan,
              'r1': data[i].user.biaya_rincian,
              'b1': this.ribu(data[i].user.biaya_tambahan),
              'r2': data[i].user.biaya_rincian_2,
              'b2': this.ribu(data[i].user.biaya_tambahan_2),
              'diskon': this.ribu(data[i].user.diskon), 
              'ppn': this.ppn+"%", 
              'total': this.ribu( ( ( parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) + (  ( (parseInt(data[i].user.ptarif) + parseInt(this.isNull(data[i].user.biaya_tambahan)) + parseInt(this.isNull(data[i].user.biaya_tambahan_2)) ) / 100 ) ) * parseInt(this.ppn)   ) - parseInt(this.isNull(data[i].user.diskon)) )
          };
          values.push(item1);
      }
      this.json_datapelanggan = values;          
      this.judulDoc = ["Pelanggan Belum "+judul+" - "+this.tglIndo(new Date)];
      this.nameDoc = "Pelanggan Belum "+judul+" - "+this.tglIndo(new Date)+".xls";
    },
    loadMore() {
      this.page = this.page + 1;

      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "isolir");
      data.append('page', this.page);
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));

      //alert(sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;
        if (x.status) {
          var data = x.data;
          var i;
          
          for (i = 0; i < data.length; i++) {
            this.pelanggan.push(data[i]);
          }
          //this.pelanggan = x.data;
          this.totalBelum = parseInt(this.totalBelum) + parseInt(x.pesan);

          //this.parseExcel(this.pelanggan, "");

        } else {
          //alert(x.pesan);
          this.pageStat = 999;
        }
      })
    },
    loadAll() {
      this.page = this.page + 1;

      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "isolir");
      data.append('page', "all");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));

      //alert(sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        this.loading = false;
        if (x.status) {
          
          this.pelanggan = x.data;
          this.totalBelum = x.pesan;

          this.parseExcel(x.data, "");
          
        } else {
          //alert(x.pesan);
          this.pageStat = 999;
        }
      })
    },
    loadAllExport() {
      console.log("lload all export")
      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "isolir");
      data.append('page', "all");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));

      //alert(sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        
      console.log(" hhasil lload all export")
        this.loading = false;
        if (x.status) {

          this.totalBelum = x.pesan;
          this.parseExcel(x.data, "");
          
        } else {
          //alert(x.pesan);
          this.pageStat = 999;
        }
      })
    },
    getData() {

      let bulan = sessionStorage.getItem('bulanIdBase');
      let tahun = sessionStorage.getItem('tahunBase');

      let cacheT = "pel_isolir-"+bulan+"-"+tahun+"-page0"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH
          this.loading = false;
          if (x.status) {
            this.pelanggan = x.data;
            this.totalBelum = x.pesan;

            //this.parseExcel(x.data, "");
            
          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }
      myGlobal.loger("baru "+cacheT);


      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "isolir");
      data.append('page', this.page);
      data.append('bulan', bulan);
      data.append('tahun', tahun);

      //alert(sessionStorage.getItem('bulanIdBase'));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {

        RedisSession.set(cacheT, x, 600000); // 10 menit

        // myGlobal.loger(x);

        this.loading = false;
        if (x.status) {
          this.pelanggan = x.data;
          this.totalBelum = x.pesan;

          //this.parseExcel(x.data, "");
          
        } else {
          //alert(x.pesan);
        }

      })
    },
  },
  mounted () {
    document.title = "List Pelanggan Isolir";
    this.namaQ = sessionStorage.getItem('admin');

    this.ppn = myGlobal.PPN();

    this.getData();

    var bulanNow = this.getBulanNow();
    this.bulanBase = bulanNow;
    this.tahunBase = this.getTahunNow();

    
		//console.log(JSON.stringify(this.$route.params));
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.tombol {
  cursor: pointer;
}
.info {
  position: absolute;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  z-index: 999999999;
  margin-top: -50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pelanggan-isolir/main.vue